/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_Suppress_SmsInputs */

const cs_viewings_suppress_sms = /** @type {(inputs: Viewings_Suppress_SmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neposílat SMS připomínky`)
};

const en_viewings_suppress_sms = /** @type {(inputs: Viewings_Suppress_SmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not send SMS reminders`)
};

/**
* | output |
* | --- |
* | "Do not send SMS reminders" |
*
* @param {Viewings_Suppress_SmsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_suppress_sms = /** @type {((inputs?: Viewings_Suppress_SmsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Suppress_SmsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_suppress_sms(inputs)
	return cs_viewings_suppress_sms(inputs)
});